export default function () {
  return [
    {
      type: 'DatePicker',
      title: '提出日期',
      [$field]: 'adviceTime',
      rules: [''],
      colSpan: 8,
      readOnly: true
    },
    {
      type: 'Input',
      title: '心声建议标题',
      [$field]: 'title',
      rules: [''],
      colSpan: 24,
      placeholder: '请输入'
    },
    {
      type: 'Checkbox',
      title: '心声建议类型',
      [$field]: 'typeCodes',
      colSpan: 8,
      optionList: this.getTypeCodesOptionList,
      rules: ['required']
    },
    {
      type: 'Input',
      title: '其他类型描述',
      [$field]: 'otherTypeDesc',
      rules: [''],
    },
    {
      type: 'Input',
      title: '所属组织',
      [$field]: 'orgName',
      rules: ['required'],
      colSpan: 24,
      readOnly: true
    },
    {
      type: 'textarea',
      title: '心声建议说明',
      [$field]: 'adviceDesc',
      rules: ['required'],
      colSpan: 24,
      placeholder: '请输入'
    }
  ]
}

export const attachmentOptions = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'fileInfo',
      readOnly: false,
      props: {
        data: {
          groupId: this.groupId
        },
        multiple: true,
        isShowFileList: true
      },
      rules: ['required']
    }
  ]
}

export const theSecondAttachmentOptions = function () {
  return [
    {
      type: 'textarea',
      title: '处理结果',
      [$field]: 'processContent',
      rules: ['required'],
      colSpan: 24,
      placeholder: '请输入'
    },
    {
      type: 'FileUpload',
      title: '附件信息',
      colSpan: 24,
      [$field]: 'fileId',
      readOnly: false,
      props: {
        data: {
          groupId: this.groupId1
        },
        multiple: true,
        isShowFileList: true
      },
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '处理时间',
      colSpan: 8,
      readOnly: true,
      [$field]: 'handleTimes',
      rules: ['']
    },
    {
      type: 'Input',
      title: '处理人',
      colSpan: 8,
      readOnly: true,
      [$field]: 'handleUserName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '处理组织',
      colSpan: 8,
      readOnly: true,
      [$field]: 'handleOrgName',
      rules: ['']
    }
  ]
}